import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
import WujieVue from 'wujie-vue2';
import { MICRO_NAME, MICRO_URL } from './constants';
import { injectService } from '@patsnap/tahiti-core';
import { HiroEntryService } from './service/hiro-entry.service';
import { GetHiroBasic } from '@/infrastructure/api-functions/core-search-api/get-hiro-basic-api';
import _ from 'lodash';
import { InstanceofPlugin, SelectionPlugin, EventTargetPlugin } from 'wujie-polyfill';


export default /*#__PURE__*/_defineComponent({
  __name: 'HiroEntry',
  setup(__props) {

const hiroEntryService = injectService<HiroEntryService>(HiroEntryService);

const wujieProps = hiroEntryService.getWujieProps();

const enabled = ref(false);

const hiroBasicService = injectService<GetHiroBasic>(GetHiroBasic);

onMounted(async () => {
    const res = await hiroBasicService.getHiroBasic();
    enabled.value = _.get(res, 'copilot_flag', false);
});


return { __sfc: true,hiroEntryService, wujieProps, enabled, hiroBasicService, WujieVue, MICRO_NAME, MICRO_URL, InstanceofPlugin, SelectionPlugin, EventTargetPlugin }
}

})